import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as rxOp from 'rxjs/operators';
import { catchError, tap } from 'rxjs/operators';
import { Activity, PaginatedList } from '../models';
import { UtilsService } from './utils.service';
import _ from 'lodash';
import { Post } from '../models/post';
import { Invite } from '../models/invite';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({ providedIn: 'root' })
export class LikeService {
  constructor(
    private http: HttpClient,
    private utils: UtilsService,
  ) { }

  list(qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:likes-list');
    return this.http
      .get<any>(url, this.utils.requestOptions(qp))
      .pipe(rxOp.map((resp: any) => {
        if (Array.isArray(resp)) return resp;
        return resp?.results || [];
      }));
  }

  get(id: string | number, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:post-detail', id);
    return this.http.get(url, this.utils.requestOptions(qp));
  }

  delete(id: string | number, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:likes-detail', id);
    return this.http.delete(url, this.utils.requestOptions(qp));
  }

  create(obj: Object, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:likes-list');
    return this.http
      .post(url, obj, this.utils.requestOptions(qp));
  }

  respond(id: number, obj?: Object, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:invites-respond', id);
    return this.http
      .post(url, obj, this.utils.requestOptions(qp));
  }

  reject(id: number, obj?: Object, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:invites-reject', id);
    return this.http
      .post(url, obj, this.utils.requestOptions(qp));
  }

  update(id: number, obj: Object, qp?: Object): Observable<any> {
    const url = this.utils.getUrl('rest:post-detail', id);
    return this.http
      .patch(url, obj, this.utils.requestOptions(qp));
  }



  
  // ERROR LOGGING
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a StockService message with the MessageService */
  private log(message: string) {
    console.log(message);
  }  

}
